import React, { useState, useEffect } from 'react';
import { Col, Container, Image, Modal, Row } from 'react-bootstrap';
import { FaTimes, FaCalendarAlt, FaLock } from 'react-icons/fa';
import { format } from 'date-fns';
const Prizes = ({ onAllPrizesEnded, allPrizesEnded }) => {
  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [hoveredImageId, setHoveredImageId] = useState(null);
  const [images, setImages] = useState([]);

  const hoverImages = {
    "Ended": "https://d2bxnt3cp18qf5.cloudfront.net/Giveaway+Ended.webp",
    "Coming Soon": "https://d2bxnt3cp18qf5.cloudfront.net/Coming+Soon.webp",
  };

  const handleShow = (image) => {
    setSelectedImage(image);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const handleMouseEnter = (id, status) => {
    if (status === 'Ended' || status === 'Coming Soon') {
      setHoveredImageId(id);
    }
  };

  const handleMouseLeave = () => {
    setHoveredImageId(null);
  };

  const getHoverIcon = (status) => {
    switch (status) {
      case 'Ended':
        return <FaLock className="hover-icon text-white" size={30} />;
      case 'Coming Soon':
        return <FaCalendarAlt className="hover-icon text-white" size={30} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const initialImages = [
      {
        id: 2,
        src: "https://d2bxnt3cp18qf5.cloudfront.net/week1-+thumb.webp",
        status: 'Coming Soon',
        date: "2025-01-18T20:00:00Z", // Start time in UTC
        image: "https://d2bxnt3cp18qf5.cloudfront.net/week1-+thumb.webp",
        validDate: "2025-01-25T20:00:00Z", // End time in UTC
        headline: "THE LOSI RZR REY BUNDLE",
        text: "RZR REY RC CAR + CONTROLLER + BATTERY + CHARGER + BLACK OPS 6 GAME"
      },
      {
        id: 1,
        src: "https://d2bxnt3cp18qf5.cloudfront.net/week2-+thumb.webp",
        status: 'Coming Soon',
        date: "2025-01-25T20:00:00Z",
        image: "https://d2bxnt3cp18qf5.cloudfront.net/week2-+thumb.webp",
        validDate: "2025-02-02T20:00:00Z",
        headline: "SCUF CONTROLLER BUNDLE",
        text: "CALL OF DUTY®: BLACK OPS 6 EDITION CONTROLLER + CASE + BLACK OPS 6 GAME"
      },
      {
        id: 3,
        src: "https://d2bxnt3cp18qf5.cloudfront.net/week3+-+thumb.webp",
        status: 'Coming Soon',
        date: "2025-02-02T20:00:00Z",
        image: "https://d2bxnt3cp18qf5.cloudfront.net/week3+-+thumb.webp",
        validDate: "2025-02-09T20:00:00Z",
        headline: "ELGATO STREAM BUNDLE",
        text: "CALL OF DUTY®: BLACK OPS 6 EDITION STREAM DECK + MIC + MIC ARM"
      },
      {
        id: 4,
        src: "https://d2bxnt3cp18qf5.cloudfront.net/week4-+thumb.webp",
        status: 'Coming Soon',
        date: "2025-02-09T20:00:00Z",
        image: "https://d2bxnt3cp18qf5.cloudfront.net/week4-+thumb.webp",
        validDate: "2025-02-17T03:59:00Z",
        headline: "ORIGIN LAPTOP BUNDLE",
        text: "CALL OF DUTY®: BLACK OPS 6 EDITION LAPTOP + HEADSET + MOUSE + MOUSE PAD + CONTROLLER"
      },
    ];

    const updateImageStatuses = () => {
      const currentDate = new Date(); // UTC date by default

      const updatedImages = initialImages.map((img) => {
        const startDate = new Date(img.date); // UTC start time
        const endDate = new Date(img.validDate); // UTC end time

        console.log("currentDate", currentDate)
        console.log("startDate", startDate)
        console.log("endDate", endDate)

        if (currentDate >= startDate && currentDate <= endDate) {
          return { ...img, status: 'active' };
        } else if (currentDate > endDate) {
          return { ...img, status: 'Ended' };
        } else {
          return { ...img, status: 'Coming Soon' };
        }
      });

      setImages(updatedImages);

      const allEnded = updatedImages.every((img) => img.status === 'Ended');
      onAllPrizesEnded(allEnded);
    };

    updateImageStatuses();
  }, [onAllPrizesEnded]);


  return (
    <>
      <Container className='pb-5'>
        {allPrizesEnded ?


          <>
            <Col xs={12} lg={8} className='mx-auto  my-5'>
              <div className="text-center rzr-section mb-1 mt-4">
                <h1 style={{ color: "#f96800" }} className=' headingtext text-wrap mb-0'>
                  THANK YOU FOR PARTICIPATING AND
                </h1>
                <h1 style={{ color: "#f96800" }} className=' headingtext text-wrap mb-0'>
                  CONGRATULATIONS TO THE WINNERS!
                </h1>
              </div>

            </Col>
          </>

          :

          <Col xs={12} lg={8} className='mx-auto'>
            <div className="text-center rzr-section mb-1 mt-4">
              <h1 className='text-white headingtext text-wrap mb-0'>
                WEEKLY PRIZE BUNDLES
              </h1>
            </div>
            <div className="rzr-under-section text-center">
              <p className='text-white paragraphtext mt-0 mt-lg-2  text-wrap mb-1'>
                RETURN EACH MONDAY <br className='d-md-none d-block' /> BETWEEN 11/18 AND 12/9
              </p>
              <p className='text-white paragraphtext mt-0 mt-lg-2  text-wrap mb-5'>
                FOR THE CHANCE TO WIN <br className='d-md-none d-block' /> ONE OF FOUR EXCLUSIVE PRIZE BUNDLES
              </p>
            </div>
          </Col>
        }


        <Row >
          {images.map((image) => (
            <Col xs={6} lg={3} key={image.id}>
              <div
                className="about-image position-relative"
                onClick={() => handleShow(image)}
                onMouseEnter={() => handleMouseEnter(image.id, image.status)}
                onMouseLeave={handleMouseLeave}
                style={{ cursor: 'pointer' }}
              >
                <Image
                  className={`${image.status === 'active' ? 'rainbow' : 'othercard'} `}
                  src={
                    hoveredImageId === image.id && hoverImages[image.status]
                      ? hoverImages[image.status]
                      : image.image
                  }
                  width="100%"
                  alt={`Prize ${image.id}`}
                />
                {(image.status === 'Ended' || image.status === 'Coming Soon') && (
                  <div className="overlay position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                    {hoveredImageId === image.id && getHoverIcon(image.status)}
                  </div>
                )}
              </div>
              <div className='text-center mt-3 mb-2'>
                <h5 className="text-white regulartext text-status">{image.status}</h5>
                <h5 className="date paragraphtext">
                  {format(new Date(image.date), 'MM/dd/yyyy')}
                </h5>
              </div>
            </Col>
          ))}
        </Row>

        {selectedImage && (
          <Modal show={show} size='lg' onHide={handleClose} centered>
            <Modal.Header className='justify-content-end bg-transparent border-0 shadow-0' style={{ background: "transparent" }}>
              <FaTimes onClick={handleClose} style={{ cursor: 'pointer', color: '#f96800', fontSize: '24px' }} />
            </Modal.Header>
            <Modal.Body className="bg-black rounded">
              <Image src={selectedImage.image} alt={`Prize ${selectedImage.id}`} width="100%" />
              <Row className='justify-content-center'>
                <Col xs={12} lg={12} >
                  <div className="mt-3 thumbnail-popup text-center">
                    <h4 className='regulartext '>{selectedImage.headline}</h4>
                    <p className='paragraphtext mt-3 text-white'>{selectedImage.text}</p>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        )}



      </Container>
    </>
  );
};

export default Prizes
